<div class="section-error-wrapper">
  <mat-icon class="error-icon material-icons-outlined">error</mat-icon>
  <p class="error-text-wrapper">
    @if (message()) {
      <span class="error-detail">{{ message() }}</span>
    } @else {
      <span>There was a problem loading the content.</span>
    }
    <span>
      Please
      <a [href]="refreshLink()" class="error-link">refresh</a>
      or try again later.
    </span>
  </p>
</div>
